import { useOnline } from '@vueuse/core';

export const useOnlineStatus = () => {
  const isOnline = useOnline();

  return {
    isOnline,
    isOffline: computed(() => !isOnline.value),
  };
};
